import get from 'lodash.get';
import status from 'src/js/modules/status';
import statusNames from '../constants/status-names';

const getSitesStatus = (rootState) => get(status.selectors.getStatus(rootState), statusNames.SITES);

export default getSitesStatus;
